import React from 'react'
import { SelectInputProps } from 'react-admin'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'
import LocalizedFieldWithChoices from './LocalilzedFieldWithChoices'

type Props = Omit<SelectInputProps, 'disabled'> & {
  forceDisabled?: boolean
}

const LocalizedSelectInput: React.FC<Props> = ({
  forceDisabled = false,
  ...props
}) => (
  <LocalizedFieldWithChoices {...props} disabled={forceDisabled}>
    <KSelectInput />
  </LocalizedFieldWithChoices>
)

export default LocalizedSelectInput
